import React, { useContext } from 'react';
import classNames from 'classnames';
import { translate } from '@fiverr-private/i18n-react';
import { AppContext } from '../../state/AppContext';
import SellerOverview from './SellerOverview';
import RedirectButton from './RedirectButton';

import style from './style.module.scss';

const OverviewCard = () => {
    const {
        gig: { subCategoryId },
    } = useContext(AppContext);
    const subCategoryName = translate(`sub_categories.sub_category_${subCategoryId}.name`);
    const title = translate('assets_sharing.overview_card.sub_category.title', { params: { subCategoryName } });

    return (
        <div className={style.overviewCard}>
            <p className={classNames(style.overviewTitle, 'text-bold', 'tbody-6')}>{title}</p>
            <div className={style.overviewBody}>
                <SellerOverview />
                <RedirectButton />
            </div>
        </div>
    );
};

export default OverviewCard;
